module.exports = __webpack_public_path__ + "static/media/32.c4622fde.jpg";